export default "__VITE_ASSET__Cl1PQwi5__"